// A strip of subtabs above a nested route's <Outlet /> (feedback #55). Used as
// the element of a parent <Route> whose children are the subtab pages, so
// each subtab has its own URL. Meal plan is the first user; the Purveyor
// Portal and Plan Defaults are meant to reuse it rather than growing their
// own tab treatments.
//
// Deliberately lighter than the top nav (underlined text, no card-style
// tabs) so the two levels read as a hierarchy. On a phone the strip scrolls
// sideways instead of wrapping, so it stays one row however many tabs a page
// has.
//
// The strip pins directly beneath the app's sticky header (--app-header-h,
// set in App.jsx), so while a subtab's page scrolls the subtabs stay in
// reach -- the same technique as Recipes' pinned search/filters. It is a
// child of this layout's wrapper, which spans the whole page, so it stays
// pinned all the way down.
import { NavLink, Outlet } from "react-router-dom";
import { useMealPlanner } from "../hooks/MealPlannerContext";
import { FONT_SIZE, SPACE } from "../lib/constants";

// `context` is handed to the subtab pages through <Outlet context>, for a
// parent that loads data they all share (read with useOutletContext()).
export function SubtabLayout({ tabs, label, context }) {
  const { colors } = useMealPlanner();
  const { paper, soft, accent, line } = colors;

  return (
    <div>
      <nav
        aria-label={label}
        className="mp-sans"
        style={{ position: "sticky", top: "var(--app-header-h, 0px)", zIndex: 10, background: paper, display: "flex", gap: SPACE.x3, marginBottom: SPACE.x3, borderBottom: `1px solid ${line}`, overflowX: "auto", whiteSpace: "nowrap", scrollbarWidth: "none" }}
      >
        {tabs.map(({ to, label: tabLabel, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className="mp-tab"
            style={({ isActive }) => ({
              padding: "var(--space-md) 0",
              fontSize: FONT_SIZE.md,
              fontWeight: isActive ? 600 : 500,
              textDecoration: "none",
              color: isActive ? accent : soft,
              borderBottom: isActive ? `2px solid ${accent}` : "2px solid transparent",
              marginBottom: -1,
              flexShrink: 0,
            })}
          >
            {tabLabel}
          </NavLink>
        ))}
      </nav>
      <Outlet context={context} />
    </div>
  );
}
